export default function handleAIError(err, { setErrorMsg, setShowLimitDialog }) {
    const status = err?.response?.status;
    const errorData = err?.response?.data;

    const rawError =
        typeof errorData === "string"
            ? errorData
            : errorData?.error || errorData?.detail || JSON.stringify(errorData);

    const errorText = rawError?.toLowerCase?.() || "";

    // Handle AI limit errors
    if (status === 403 && errorText.includes("limit")) {
        if (typeof setShowLimitDialog === "function") setShowLimitDialog(true);
        if (typeof setErrorMsg === "function") setErrorMsg(""); // suppress Snackbar
        return;
    }

    // Handle input validation errors (400 status with validation details)
    if (status === 400 && errorData?.details && Array.isArray(errorData.details)) {
        const validationMessage = formatValidationError(errorData);
        if (typeof setErrorMsg === "function") setErrorMsg(validationMessage);
        return;
    }

    // Handle other validation errors
    if (status === 400 && (
        errorText.includes("validation failed") ||
        errorText.includes("required") ||
        errorText.includes("characters") ||
        errorText.includes("invalid")
    )) {
        const friendlyMessage = formatInputError(rawError);
        if (typeof setErrorMsg === "function") setErrorMsg(friendlyMessage);
        return;
    }

    // Handle general errors
    if (typeof setErrorMsg === "function") {
        setErrorMsg(rawError || "Failed to generate response.");
    }
}

function formatValidationError(errorData) {
    const details = errorData.details || [];
    const mainMessage = "Please check your input";
    
    if (details.length === 1) {
        return `${mainMessage}: ${details[0]}`;
    } else if (details.length > 1) {
        const firstTwo = details.slice(0, 2);
        const remaining = details.length - 2;
        let message = `${mainMessage}:\n• ${firstTwo.join('\n• ')}`;
        if (remaining > 0) {
            message += `\n• ... and ${remaining} more issue${remaining > 1 ? 's' : ''}`;
        }
        return message;
    }
    
    return mainMessage;
}

function formatInputError(rawError) {
    const error = rawError || "";
    
    // Map common validation errors to friendly messages
    if (error.includes("must be under") && error.includes("characters")) {
        return "Your input is too long. Please shorten it and try again.";
    }
    
    if (error.includes("required") || error.includes("cannot be empty")) {
        return "Please fill in all required fields before continuing.";
    }
    
    if (error.includes("malicious content") || error.includes("invalid characters")) {
        return "Please check your text for any unusual characters or formatting and try again.";
    }
    
    if (error.includes("YouTube URL") || error.includes("youtube.com") || error.includes("youtu.be")) {
        return "Please enter a valid YouTube URL (e.g., https://youtube.com/watch?v=...).";
    }
    
    if (error.includes("Grade")) {
        return "Please select a valid grade level (K, KG, or 1-12).";
    }
    
    // Return a cleaned version of the original error if no specific mapping
    return error.replace(/[{}[\]]/g, '').trim() || "Please check your input and try again.";
}
